module.exports = __webpack_public_path__ + "static/media/testomonialimg2.3898e80c.png";